import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import AppProviders from './context';
import {LOCAL_STORAGE_KEY} from './constants/localStorage';
import 'intl-pluralrules';

import './i18n';

function isElectron() {
  // Renderer process
  if (typeof window !== 'undefined' && typeof window.process === 'object' && window.process.type === 'renderer') {
      return true;
  }

  // Main process
  if (typeof process !== 'undefined' && typeof process.versions === 'object' && !!process.versions.electron) {
      return true;
  }

  // Detect the user agent when the `nodeIntegration` option is set to true
  if (typeof navigator === 'object' && typeof navigator.userAgent === 'string' && navigator.userAgent.indexOf('Electron') >= 0) {
      return true;
  }

  return false;
}

const renderReactDom = () => {
  ReactDOM.render(
    <AppProviders>
      <App />
    </AppProviders>,
    document.getElementById('root')
  );
};

if (window.cordova) {
  document.addEventListener('deviceready', () => {
    // die folgende Zeile wurde auskommentiert weil sonst 
    // der Mandant nach Logout rausgeschmissen wurde
    //localStorage.setItem(LOCAL_STORAGE_KEY.client, '');
    renderReactDom();
  }, false);
} else {
  if (isElectron()) {
    // entfernt, weil Mandant nach wondow.location.reload verloren geht ...
    //localStorage.setItem(LOCAL_STORAGE_KEY.client, '');
    if (localStorage.getItem(LOCAL_STORAGE_KEY.saveUsername) === 'false') {
      localStorage.setItem(LOCAL_STORAGE_KEY.username, "");
    }
    window.process?.argv.forEach(element => {
      if (element.startsWith('--token=')) {
        sessionStorage.setItem(LOCAL_STORAGE_KEY.accessToken, element.slice(8));
        localStorage.setItem(LOCAL_STORAGE_KEY.username, '');
      }
      if (element.startsWith('--path=')) {
        //navigate(element.slice(7));
        localStorage.setItem(LOCAL_STORAGE_KEY.path, element.slice(7));
      }
      if (element.startsWith('--client=')) {
        localStorage.setItem(LOCAL_STORAGE_KEY.client, element.slice(9))
      }
    });
  }
  ReactDOM.render(
    <AppProviders>
      <App />
    </AppProviders>,
    document.getElementById('root')
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
